import apiServices, { connectorClient } from "../utils/axios";

export const fetchGetTransform = async () => {
    const res = await apiServices.get(`/transform`);
    return res.data;
};

export const fetchGetTransformTemplates = async () => {
    const res = await apiServices.get(`/transform/templates`);
    return res.data;
};

export const fetchGetDetailTransform = async (id) => {
    const res = await apiServices.get(`/transform/${id}`);
    return res.data;
};


export const fetchAddTransform = async (payload) => {
    const res = await apiServices.post(`/transform`, payload);
    return res.data;
};

export const fetchDeleteTransform = async (id) => {
    const { data } = await apiServices.delete(`/transform/${id}`);
    return data;
  };

export const fetchTransformNewExtraction = async (payload) => {
    const { data } = await apiServices.post(`/transform/extract`, payload);
    return data;
  };

